// Shared Swiper loader — prevents duplicate CDN requests
let swiperLoadCallbacks = [];
let swiperLoading = false;
function loadSwiper(callback) {
  if (typeof Swiper !== "undefined") {
    callback();
    return;
  }
  swiperLoadCallbacks.push(callback);
  if (swiperLoading) return;
  swiperLoading = true;

  const swiperStyles = document.createElement("link");
  swiperStyles.rel = "stylesheet";
  swiperStyles.href = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css";
  document.head.appendChild(swiperStyles);

  const swiperScript = document.createElement("script");
  swiperScript.src = "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
  swiperScript.onload = function() {
    swiperLoadCallbacks.forEach(function(cb) { cb(); });
    swiperLoadCallbacks = [];
  };
  swiperScript.onerror = function() {
    console.error('Failed to load Swiper');
  };
  document.head.appendChild(swiperScript);
}

document.addEventListener("DOMContentLoaded", function () {
  // Detect if page is viewed in the Shopify admin
  if (window.self !== window.top) {
    document.body.classList.add("is-admin");
  }

  // Custom Header Styles
  const navbar = document.querySelector(".site-header");

  const isProductPage = document.body.classList.contains("template-product");
  const isAllCollectionsPage = document.body.classList.contains("template-list-collections");
  const is404Page = document.body.classList.contains("template-404");
  const isSearchPage = document.body.classList.contains("template-search");

  if (isProductPage || isAllCollectionsPage || is404Page || isSearchPage ) {
      navbar.classList.add("navStyles");
      navbar.classList.add("navStylesAlt");
  }

  if (isAllCollectionsPage && window.self === window.top) {
      window.location.href = "/collections/all-products";
  }

  let scrollTicking = false;
  window.addEventListener("scroll", function () {
    if (!scrollTicking) {
      requestAnimationFrame(function () {
        const scrollY = window.scrollY;

        if (scrollY > 1 || isProductPage || isAllCollectionsPage || is404Page || isSearchPage ) {
          navbar.classList.add("navStyles");
          navbar.classList.add("navStylesAlt");
        } else {
          navbar.classList.remove("navStyles");
          navbar.classList.remove("navStylesAlt");
        }

        scrollTicking = false;
      });
      scrollTicking = true;
    }
  });

  // In good company section — manually trigger AOS animations via IntersectionObserver
  // because AOS position tracking can miss this section after layout shifts
  const inGoodCompanySection = document.querySelector(".template-index .shopify-section:has(.text-column__grid)");
  if (inGoodCompanySection) {
    var igcObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var aosElements = inGoodCompanySection.querySelectorAll('[data-aos]');
          aosElements.forEach(function(el) {
            el.classList.add('aos-animate');
          });
          igcObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    igcObserver.observe(inGoodCompanySection);
  }
  if( inGoodCompanySection && window.innerWidth <= 768 ) {
  const initCarousel = function() {
    const clone = inGoodCompanySection.cloneNode(true);
    clone.classList.add("in-good-company-clone");
    // add display block on the cloned section
    clone.style.display = "block";

    // Transform the cloned content into Swiper structure
    buildSwiperHTML(clone);

    inGoodCompanySection.after(clone);

    loadSwiper(startSwiper);

    function buildSwiperHTML(cloneElement) {
      // Get all image elements from the original structure
      const images = cloneElement.querySelectorAll('img');
      const sectionHeader = cloneElement.querySelector('.section-header');

      // Create Swiper structure
      const lookbookSection = document.createElement('div');
      lookbookSection.className = 'lookbook-section';

      // Add header if it exists
      if (sectionHeader) {
        const lookbookHeader = document.createElement('div');
        lookbookHeader.className = 'lookbook-header';

        const title = sectionHeader.querySelector('h2');
        if (title) {
          const lookbookTitle = document.createElement('h2');
          lookbookTitle.className = 'lookbook-title';
          lookbookTitle.textContent = title.textContent;
          lookbookHeader.appendChild(lookbookTitle);
        }

        const description = sectionHeader.querySelector('.section-description p');
        if (description) {
          const lookbookDescription = document.createElement('p');
          lookbookDescription.className = 'lookbook-description';
          lookbookDescription.textContent = description.textContent;
          lookbookHeader.appendChild(lookbookDescription);
        }

        lookbookSection.appendChild(lookbookHeader);
      }

      // Create Swiper container
      const swiperContainer = document.createElement('div');
      swiperContainer.className = 'swiper-container';
      swiperContainer.id = 'swiper-in-good-company';

      const swiperWrapper = document.createElement('div');
      swiperWrapper.className = 'swiper-wrapper';

      // Convert each image to a Swiper slide
      images.forEach(function(img, index) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';

        const slideContent = document.createElement('div');
        slideContent.className = 'slide-content';

        const slideImg = document.createElement('img');
        slideImg.src = img.src;
        slideImg.srcset = img.srcset || '';
        slideImg.sizes = '85vw';
        slideImg.alt = img.alt || '';
        slideImg.loading = 'lazy';
        slideImg.className = 'slide-bg-img';
        slideImg.width = img.width || '';
        slideImg.height = img.height || '';

        slideContent.appendChild(slideImg);
        slide.appendChild(slideContent);
        swiperWrapper.appendChild(slide);
      });

      swiperContainer.appendChild(swiperWrapper);
      lookbookSection.appendChild(swiperContainer);

      // Replace the original content with the new Swiper structure
      const pageWidth = cloneElement.querySelector('.page-width');
      pageWidth.innerHTML = '';
      pageWidth.appendChild(lookbookSection);

      // Add necessary styles
      addSwiperStyles(cloneElement);
    }

    function addSwiperStyles(cloneElement) {
      const styles = document.createElement('style');
      styles.textContent = `
        @media (min-width: 769px) {
        .in-good-company-clone {
          display: none !important;
        }
        }
        .in-good-company-clone .lookbook-section {
          padding: 40px 0;
        }

        .in-good-company-clone .lookbook-header {
          text-align: center;
          margin-bottom: 40px;
          max-width: 800px;
          margin-left: auto;
          margin-right: auto;
        }

        .in-good-company-clone .lookbook-title {
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 16px;
          color: #333;
        }

        .in-good-company-clone .lookbook-description {
          font-size: 1.1rem;
          line-height: 1.6;
          color: #555;
          margin: 0;
        }

        .in-good-company-clone .swiper-container {
          width: 100%;
          height: 400px;
          position: relative;
          overflow: hidden;
        }

        .in-good-company-clone .swiper-slide {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 400px;
          border-radius: 10px;
          overflow: hidden;
          flex-shrink: 0;
        }

        .in-good-company-clone .slide-content {
          width: 100%;
          height: 100%;
          position: relative;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }
        .in-good-company-clone .slide-bg-img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
        }
      `;
      cloneElement.appendChild(styles);
    }

    function startSwiper() {
        const swiper = new Swiper('#swiper-in-good-company', {
          loop: true,
          effect: 'slide',
          speed: 600,
          spaceBetween: 20,
          slidesPerView: 1.3,
          centeredSlides: true,
          initialSlide: 1,
        });
    }
  };
  // Defer heavy DOM work to avoid blocking the main thread
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initCarousel);
  } else {
    setTimeout(initCarousel, 1);
  }
  }
});


/* Simplified Instagram feed to Swiper conversion - Improved initialization */
const instagramShowSection = document.querySelector(".shopify-section:has(#insta-feed)");

if (instagramShowSection && window.innerWidth <= 768) {

  function createInstagramSwiper() {
    // Check if clone already exists
    if (document.querySelector(".instagram-feed-clone")) {
      return;
    }

    // Get Instagram feed elements directly
    const instagramSource = document.querySelector(".instafeed-new-layout-wrapper");
    if (!instagramSource) return;

    const instagramItems = instagramSource.querySelectorAll('.instafeed-new-layout-item');

    // Filter valid images and extract links from parent containers
    const validSlides = [];
    instagramItems.forEach(function(item) {
      const img = item.querySelector('img');
      const link = item.querySelector('a');

      if (img) {
        const imgSrc = img.getAttribute('data-instafeed-src') || img.src;
        if (imgSrc &&
            !imgSrc.includes('placeholder.png') &&
            !imgSrc.includes('video-icon') &&
            !imgSrc.includes('instagram-icon') &&
            img.classList.contains('instafeed-lazy-image--handled')) {
          validSlides.push({
            src: imgSrc,
            link: link ? link.href : '#'
          });
        }
      }
    });

    // Need at least 4 images
    if (validSlides.length < 4) return;

    // Clone the section and build Swiper
    const instagramClone = instagramShowSection.cloneNode(true);
    instagramClone.classList.add("instagram-feed-clone");
    instagramClone.style.display = "block";

    buildInstagramSwiperHTML(instagramClone, validSlides);
    instagramShowSection.after(instagramClone);

    // Initialize everything once DOM is ready
    initializeSwiperWhenReady();

    document.body.classList.add("insta-feed-loaded");
  }

  function buildInstagramSwiperHTML(cloneElement, slides) {
    const sectionHeader = cloneElement.querySelector('#insta-feed h2, div[style*="text-align:center"] h2');
    const sectionSubtext = cloneElement.querySelector('div[style*="text-align:center"] p');

    // Create Swiper structure
    const lookbookSection = document.createElement('div');
    lookbookSection.className = 'lookbook-section';

    // Add header if it exists
    if (sectionHeader) {
      const lookbookHeader = document.createElement('div');
      lookbookHeader.className = 'lookbook-header';

      const lookbookTitle = document.createElement('h2');
      lookbookTitle.className = 'lookbook-title';
      lookbookTitle.textContent = sectionHeader.textContent;
      lookbookHeader.appendChild(lookbookTitle);

      if (sectionSubtext) {
        const lookbookDescription = document.createElement('p');
        lookbookDescription.className = 'lookbook-description';
        lookbookDescription.textContent = sectionSubtext.textContent;
        lookbookHeader.appendChild(lookbookDescription);
      }

      lookbookSection.appendChild(lookbookHeader);
    }

    // Create Swiper container
    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper-container';
    swiperContainer.id = 'swiper-instagram-feed';

    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper-wrapper';

    // Create slides from valid images
    slides.forEach(function(slide) {
      const slideElement = document.createElement('div');
      slideElement.className = 'swiper-slide';

      const slideLink = document.createElement('a');
      slideLink.href = slide.link;
      slideLink.target = '_blank';
      slideLink.rel = 'noopener nofollow';
      slideLink.className = 'slide-link';

      const slideContent = document.createElement('div');
      slideContent.className = 'slide-content';

      const slideImg = document.createElement('img');
      slideImg.src = slide.src;
      slideImg.alt = 'Instagram post';
      slideImg.loading = 'lazy';
      slideImg.className = 'slide-bg-img';

      slideContent.appendChild(slideImg);
      slideLink.appendChild(slideContent);
      slideElement.appendChild(slideLink);
      swiperWrapper.appendChild(slideElement);
    });

    swiperContainer.appendChild(swiperWrapper);
    lookbookSection.appendChild(swiperContainer);

    // Replace content
    const pageWidth = cloneElement.querySelector('.page-width');
    pageWidth.innerHTML = '';
    pageWidth.appendChild(lookbookSection);

    // Add styles
    addInstagramSwiperStyles(cloneElement);
  }

  function addInstagramSwiperStyles(cloneElement) {
    const styles = document.createElement('style');
    styles.textContent = `
      @media (min-width: 769px) {
        .instagram-feed-clone {
          display: none !important;
        }
      }

      @media (max-width: 768px) {
        body.insta-feed-loaded .shopify-section:has(#insta-feed) {
          display: none;
        }
      }

      .instagram-feed-clone .lookbook-section {
        padding: 40px 0;
      }

      .instagram-feed-clone .lookbook-header {
        text-align: center;
        margin-bottom: 40px;
        max-width: 800px;
        margin-left: auto;
        margin-right: auto;
      }

      .instagram-feed-clone .lookbook-title {
        font-size: 2.5rem;
        font-weight: bold;
        margin-bottom: 16px;
        color: #333;
      }

      .instagram-feed-clone .lookbook-description {
        font-size: 1.1rem;
        line-height: 1.6;
        color: #555;
        margin: 0;
      }

      .instagram-feed-clone .swiper-container {
        width: 100%;
        height: 400px;
        position: relative;
        overflow: hidden;
      }

      .instagram-feed-clone .swiper-slide {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 400px;
        border-radius: 10px;
        overflow: hidden;
        flex-shrink: 0;
      }

      .instagram-feed-clone .slide-link {
        display: block;
        width: 100%;
        height: 100%;
        text-decoration: none;
        color: inherit;
        cursor: pointer;
      }

      .instagram-feed-clone .slide-content {
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }
      .instagram-feed-clone .slide-bg-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center;
      }
    `;
    cloneElement.appendChild(styles);
  }

  // Simplified initialization - wait for everything to be ready
  function initializeSwiperWhenReady() {
    // Function to check if everything is ready
    function isEverythingReady() {
      return document.querySelector('#swiper-instagram-feed') &&
             document.querySelector('#swiper-instagram-feed .swiper-slide');
    }

    // Function to load Swiper and start it
    function loadAndStartSwiper() {
      loadSwiper(startSwiper);
    }

    // Initialize Swiper
    function startSwiper() {
      try {
        const swiperContainer = document.querySelector('#swiper-instagram-feed');
        if (!swiperContainer) {
          console.error('Swiper container not found');
          return;
        }

        const instagramSwiper = new Swiper('#swiper-instagram-feed', {
          loop: true,
          effect: 'slide',
          speed: 600,
          spaceBetween: 20,
          slidesPerView: 1.3,
          centeredSlides: true,
          initialSlide: 1,
        });
      } catch (error) {
        console.error('Error initializing Swiper:', error);
      }
    }

    // Wait for DOM to be ready, then load Swiper
    if (isEverythingReady()) {
      // Use setTimeout to ensure DOM is fully rendered
      setTimeout(loadAndStartSwiper, 100);
    } else {
      // Fallback: wait a bit and try again
      setTimeout(function() {
        if (isEverythingReady()) {
          loadAndStartSwiper();
        } else {
          console.warn('Swiper elements not ready after timeout');
        }
      }, 500);
    }
  }

  // Main initialization - simplified approach
  function waitForInstagramFeed() {
    let instagramSource = document.querySelector(".instafeed-new-layout-wrapper");
    let validImages = instagramSource ? instagramSource.querySelectorAll('.instafeed-lazy-image--handled') : [];

    if (instagramSource && validImages.length >= 4) {
      createInstagramSwiper();
    } else {
      // Check every 300ms, up to 10 seconds
      let attempts = 0;
      const maxAttempts = 33; // ~10 seconds

      const checkInterval = setInterval(function() {
        attempts++;
        instagramSource = document.querySelector(".instafeed-new-layout-wrapper");
        validImages = instagramSource ? instagramSource.querySelectorAll('.instafeed-lazy-image--handled') : [];

        if ((instagramSource && validImages.length >= 4) || attempts >= maxAttempts) {
          clearInterval(checkInterval);
          if (instagramSource && validImages.length >= 4) {
            createInstagramSwiper();
          } else {
            console.warn('Instagram feed not ready after maximum attempts');
          }
        }
      }, 300);
    }
  }

  // Start the process
  waitForInstagramFeed();
}
